"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var buildThemes_1 = require("../formulas/buildThemes");
/**
 * Memoized hook for building Block themes
 */
var useBuildThemes = function (_a) {
    var _b, _c;
    var primary = _a.primary, secondary = _a.secondary, background = _a.background, mood = _a.mood, safeMode = _a.safeMode, preferFormula = _a.preferFormula, bodyFont = _a.bodyFont, headingFont = _a.headingFont;
    var themeColors = (0, react_1.useMemo)(function () { return ({ primary: primary, secondary: secondary, background: background, mood: mood }); }, [primary, secondary, background, mood]);
    var hasThemeColors = primary && secondary && background && mood;
    var bodyFontMemo = (0, react_1.useMemo)(function () { return bodyFont; }, [bodyFont === null || bodyFont === void 0 ? void 0 : bodyFont.name, (_b = bodyFont === null || bodyFont === void 0 ? void 0 : bodyFont.styles) === null || _b === void 0 ? void 0 : _b.length]);
    var headingFontMemo = (0, react_1.useMemo)(function () { return headingFont; }, [headingFont === null || headingFont === void 0 ? void 0 : headingFont.name, (_c = headingFont === null || headingFont === void 0 ? void 0 : headingFont.styles) === null || _c === void 0 ? void 0 : _c.length]);
    var themes = (0, react_1.useMemo)(function () {
        if (hasThemeColors) {
            return (0, buildThemes_1.buildThemes)(themeColors, safeMode, preferFormula, bodyFont, headingFont);
        }
        return null;
    }, [hasThemeColors, themeColors, safeMode, preferFormula, bodyFontMemo, headingFontMemo]);
    return { themes: themes, themeColors: themeColors };
};
exports.default = useBuildThemes;
//# sourceMappingURL=useBuildThemes.js.map